import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Headermain from "../header";
import Footer from "../footer";
import { SinglePage } from "../pages/singlepage";
import "./App.css";

export default function App() {
  return (
    <>
      <Headermain />
      <div className="app__shell">
        <SinglePage />
      </div>
      <Footer />
    </>
  );
}
